import { Card, Skeleton } from 'atp-react-ui';

export function TakenOdtCourseCardSkeleton() {
  return (
    <Card>
      <Skeleton className="h-36 w-72 overflow-hidden rounded-lg" />
    </Card>
  );
}
